// src/pages/PerformanceAssessments/PendingPerformanceAssessments.js
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { CBadge, CCard, CCardBody, CCardHeader } from '@coreui/react';

import { apiClient } from 'services/Api';
import DataTableComponent from 'components/DataTableComponent';
import ToastNotification from 'components/globals/ToastNotification';
import PerformanceAssessmentModal from './performanceAssessmentModal';
import { ROLE_LABELS } from './questions';

const PendingPerformanceAssessments = ({ selectedYear }) => {
    const [assessments, setAssessments] = useState([]);
    const [toast, setToast] = useState(null);

    const [modalOpen, setModalOpen] = useState(false);
    const [activeAssessment, setActiveAssessment] = useState(null);

    const fetchAssessments = useCallback(
        async (year = selectedYear) => {
            try {
                const response = await apiClient.get(
                    `/performance-assessments/?year=${year}`
                );
                const data = response.data || [];
                setAssessments(data);            } catch (error) {
                console.error('Error fetching performance assessments (evaluator):', error);
                setToast({
                    title: 'Avaliação de Desempenho',
                    message: 'Erro ao carregar avaliações.',
                    type: 'error',
                });
            }
        },
        [selectedYear]
    );

    useEffect(() => {
        fetchAssessments(selectedYear);
    }, [selectedYear, fetchAssessments]);

    const openModalForAssessment = (row) => {
        setActiveAssessment(row);
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
        setActiveAssessment(null);
    };

    const columns = useMemo(
        () => [
            {
                name: 'Avaliado',
                selector: (row) => row.evaluatee_name,
                sortable: true,
                cell: (row) => (
                    <button
                        type="button"
                        className="btn btn-link p-0 text-decoration-none"
                        onClick={() => openModalForAssessment(row)}
                    >
                        {row.evaluatee_name}
                    </button>
                ),
            },
            {
                name: 'Departamento',
                selector: (row) => row.department_name,
                sortable: true,
            },
            {
                name: 'Função',
                selector: (row) => ROLE_LABELS[row.role] || row.role,
                sortable: true,
            },
            {
                name: 'Estado',
                selector: (row) => (row.concluded ? 'Concluída' : 'Em aberto'),
                sortable: true,
                cell: (row) =>
                    row.concluded ? (
                        <CBadge color="success">Concluída</CBadge>
                    ) : (
                        <CBadge color="secondary">Em aberto</CBadge>
                    ),
            },
        ],
        []
    );

    return (
        <>
            <ToastNotification toast={toast} setToast={setToast} />

            <CCard className="mb-4">
                <CCardHeader>
                    <h4 className="mb-0">Avaliações a Realizar (como avaliador)</h4>
                </CCardHeader>
                <CCardBody>
                    <DataTableComponent
                        columns={columns}
                        data={assessments}
                    />
                </CCardBody>
            </CCard>

            <PerformanceAssessmentModal
                visible={modalOpen}
                onClose={closeModal}
                assessment={activeAssessment}
                onSaved={() => fetchAssessments(selectedYear)}
            />
        </>
    );
};

export default PendingPerformanceAssessments;
